import { IMagazineHamburgerMenu, IMagazineHamburgerMenuAction } from 'models/magazine/magazinehamburgermenu';

/** Action Types */
export const SET_IS_MENU_OPENED: string = 'magazinehamburgermenu/SET_IS_MENU_OPENED';

/** Initial State */
const initialState: IMagazineHamburgerMenu = {
	isOpened: false,
};

/** Reducer */
export function magazineHamburgerMenuReducer(state = initialState, action: IMagazineHamburgerMenuAction) {
	switch (action.type) {
		case SET_IS_MENU_OPENED:
			return Object.assign({}, state, {
				isOpened: action.payload.isOpened,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function setIsMagazineHamburgerMenuOpened(isOpened: boolean): IMagazineHamburgerMenuAction {
	return {
		type: SET_IS_MENU_OPENED,
		payload: {
			isOpened,
		},
	};
}
